import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const SettlementIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <path d="m2 10 5-4 5 4M3.5 9v7h5M6 16v-4h2" />
    <path d="m12 8 4-3 5 4M14 7v3m6-2v7h-2" />
    <path d="m8 15 5-4 5 4M9.5 14v7h7v-7M12 21v-4h2v4M2 21h20" />
  </svg>
);

export default SettlementIcon;
